import { render } from "./recoveryInprogress.vue?vue&type=template&id=68e42a68"
import script from "./recoveryInprogress.vue?vue&type=script&lang=js"
export * from "./recoveryInprogress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__